export default {
  props: {
    imageSrc: {
      type: String,
      default: '',
    },
    imageAlt: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Laborum fugiat eu ad nulla irure!',
    },
    text: {
      type: String,
      default:
        'Magna nostrud ut esse fugiat mollit cupidatat eu occaecat officia. Do veniam exercitation qui in ea anim non qui consectetur non. Tempor do est ullamco ad velit fugiat Lorem exercitation tempor incididunt. Reprehenderit cillum laboris sint cillum eu labore incididunt amet dolor exercitation magna. Fugiat pariatur velit commodo in nulla enim culpa fugiat ea magna culpa labore ipsum. Voluptate et et amet proident ipsum reprehenderit dolor. Tempor anim Lorem reprehenderit id duis incididunt deserunt.',
    },
    callToAction: {
      type: String,
      default: 'Laborum fugiat >',
    },
    target: {
      type: String,
      default: '/#',
    },
    slides: {
      type: Array,
      default: () => [],
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
  },
}
